import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const InputContainer = styled.div((props) => ({
  display: 'flex',
  flex: 1,
  marginRight: '0px',

  '&.halfRow': {
    flex: 'none',  
    width: 'auto',
  },

  '.editableTextInput':{
    'input':{
      borderColor: '#85b7d9'
    }
  },

  '.editableNumberInput':{
    'input':{
      borderColor: '#85b7d9 !important'
    }
  },

  '.editableTabSelectionInput':{
    '>div':{
      borderColor: '#85b7d9 !important'
    }
  },

  '.editableDateInput':{
    'input':{
      borderColor: '#85b7d9 !important'
    }
  },

  '.editableTextAreaInput':{
    'textarea':{
      borderColor: '#85b7d9'
    }
  },

  '.editableSelectInput':{
    '>div':{
      borderColor: '#85b7d9 !important'
    },
    '.default.text':{
      color:'black !important'
    }

  },

  '.selectInputNoBorder':{
    '>div':{
      borderColor: 'transparent !important'
    },
  },

  '.inputNoBorder':{
    'input':{
      borderColor: 'transparent !important'
    },
  },

  '.disableSelectInput':{
    'i':{
      display: 'none !important'
    }
  },

  '&.fileInput': {
    flex: 'none', 
    width: '30%', 
    minWidth: '290px'
  },
  
  'input':{
    fontFamily: 'IBM Plex Sans Thai !important'
  },

  'textarea': {
    fontFamily: 'IBM Plex Sans Thai !important',
    borderRadius: '4px',
    padding: '6px 10px',
    border: '1px solid rgba(34,36,38,.15)',
  },

  'textarea.error': {
    backgroundColor: '#fff6f6',
    borderColor: '#e0b4b4',
    color: '#9f3a38',
    boxShadow: 'none',
  },

  'textarea:focus': {
    borderColor: '#85b7d9',
  },

  'textarea::placeholder': {
    color: '#CDCDCD',
  },

  'div.fieldRow': {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: '15px',

    'span.fieldLabel': {
      fontSize: '1rem',
      color: v.textGray,

      'span.require': {
        marginLeft: '4px',
        color: v.textError,
      }
    },

    'div.fieldLabel': {
      fontSize: '1rem',
      color: v.textGray,
      display:'flex',
      whiteSpace:'nowrap',
      alignItems:'center',

      'div.require': {
        marginLeft: '4px',
        color: v.textError,
      }
    },

    'div.radioV':{
      flexDirection: 'row !important',
      margin:'0.5rem 0',

      'label':{
        fontSize:'1.2rem',
        // fontWeight:'bold'
      },

      'div':{
        marginLeft:'1rem'
      },

      'div:first-child':{
        marginLeft:0
      }
    },

    'div.fieldInput': {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      width: '100%',

      '.ellipsis':{
        'input':{
          textOverflow: 'ellipsis !important',
          overflow: 'hidden !important'
        }
      },

      '&.textFieldInput': {
        'input': {
          lineHeight: '1.75rem !important',
          minHeight: '1.5rem',
          overflowX: 'hidden !important',
          overflowY: 'visible !important',
        },
      },

      '.disabled':{
        background:'#fff !important',
        color:'#000',
        opacity:'1 !important'
      },

      '[disabled]':{
        background:'#fff !important',
        color:'#000',
        opacity:'1 !important'
      },

      '.ui.disabled': {
        opacity: '.8',
      },

      '.ui.disabled.search': {
        opacity: '.8',
        background: '#F4F4F4',
      },

      '.ui.fluid.input': {
        display: 'flex',
        width: 'inherit',
      },

      'input[disabled]': {
        opacity: '.8',
        background: '#F4F4F4',
      },

      '.ui.basic.buttons': {
        'button.ui.blue.active.button': {
          color: '#FFF !important',
          backgroundColor: '#2185d0 !important',
        },

        'button.ui.red.active.button': {
          color: '#FFF !important',
          backgroundColor: '#db2828 !important',
        }
      },

      '.react-datepicker-wrapper': {
        width: '100%',
        display: 'flex',
        flex: 1,

        '.react-datepicker__input-container': {
          width: '100%',
          display: 'flex',
          flex: 1,
          
          '.dateInput': {
            border: '1px solid rgba(34,36,38,.15)',
            color: 'rgba(0,0,0,.87)',
            borderRadius: '4px',
            width: '100%',
            display: 'flex',
            flex: 1,
            padding: '9.5px 14px',
          },
        },
      },
    },

    'div.fieldInput.error': {
      '.react-datepicker-wrapper': {
        '.react-datepicker__input-container': {
          '.dateInput': {
            backgroundColor: '#fff6f6',
            borderColor: '#e0b4b4',
            color: '#9f3a38',
            boxShadow: 'none',
          },
        },
      },
    },
  },

  'div.fieldRow.marginLess': {
    margin: '0px',
  },

  '.error, .error::before, .error::after': {
    color: v.textError,
    borderBottomColor: v.textError,
  },

  '@media only screen and (min-width: 600px)': {
    '&.halfRow': {
      width: 'calc(50% - 15px)',
    },

    marginRight: '15px',
  },

  '@media only screen and (min-width: 769px)': {
    '&.halfRow': {
      width: 'calc(50% - 15px)',
    },

    marginRight: '15px',
  },
}))

export const SwitchContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: '5px',

  '.inputContent': {
    padding: '3px 0px',
    margin: '0px 5px',
  }
})
